import { SLIDE_READING_TILES } from "../../content/resources";
import { t } from "../../i18n/dict";
import { Page } from "../../layout/Page";
import { Reveal } from "../../ui/Reveal";
import { Section } from "../../ui/Section";
import { Tile } from "../../ui/Tile";

/**
 * The old site's `/slide-reading`: six concept tiles, verbatim
 * descriptions. Meditation Practice opens the practice-guide PDF; the other
 * five open the slide gallery at `/resources/slides`. English only - no
 * Hindi twin.
 */
export function SlideReadingPage() {
  return (
    <Page title="Slides Reading" heading="Slides Reading">
      <Section>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SLIDE_READING_TILES.map((tile) => (
            <Reveal key={tile.href + tile.title}>
              <Tile
                tone={tile.tone}
                title={tile.title}
                sub={tile.desc}
                href={tile.href}
                external={tile.external}
                label={tile.external ? t("en", "download") : "View Slides"}
              />
            </Reveal>
          ))}
        </div>
      </Section>
    </Page>
  );
}
